import '@babel/polyfill'; // needed to transpile async/await in babel-transpiled webpack output
import { init as init3D } from './v1/index';

function init(params) {
  console.log('threekit init:', params);
  return init3D(params);
}

window.threekit = { init };
